import LoginService from "./login.service"

export default LoginService;